import {Stack} from "@fluentui/react";
import {animated, useSpring} from "@react-spring/web";

import styles from "./Answer.module.css";
import {AnswerIcon} from "./AnswerIcon";

import {Sparkle28Filled} from "@fluentui/react-icons";

export const AnswerLoading = () => {
    const animatedStyles = useSpring({
        from: {opacity: 0},
        to: {opacity: 1}
    });

    return (
        <animated.div style={{...animatedStyles}}>
            <Stack className={styles.answerContainer} verticalAlign="space-between">
                <AnswerIcon />
                <Stack.Item grow>
                    <p className={styles.answerText}>
                        <Sparkle28Filled
                            primaryFill={"rgba(250, 96, 0, 1)"}
                            aria-hidden="true"
                            aria-label="Answer logo"
                        />
                        Generating answer
                        <span className={styles.loadingdots} />
                    </p>
                </Stack.Item>
            </Stack>
        </animated.div>
    );
};
